import { useState } from "react";
import { Heart, ArrowRight, Repeat } from "lucide-react";
import { trackEvent } from "../hooks/useAnalytics";

const DONORBOX_SLUG = "ayudanos-934402";
const PRESETS = [5, 10, 20, 50];

export default function DonationWidget({ compact = false }) {
  const [amount, setAmount] = useState(10);
  const [custom, setCustom] = useState("");
  const [recurring, setRecurring] = useState(false);

  const activeAmount = custom ? Number(custom) : amount;
  const valid = activeAmount > 0;

  const donate = () => {
    if (!valid) return;
    trackEvent(`donation_click:${activeAmount}${recurring ? ":m" : ":o"}`);
    const params = new URLSearchParams({
      amount: String(activeAmount),
      default_interval: recurring ? "m" : "o",
    });
    window.open(`https://donorbox.org/${DONORBOX_SLUG}?${params.toString()}`, "_blank", "noopener");
  };

  return (
    <div className={`w-full max-w-xl mx-auto ${compact ? "" : "p-2"}`}>
      <div className="flex flex-wrap gap-2 justify-center">
        {PRESETS.map((v) => (
          <button
            key={v}
            type="button"
            onClick={() => { setAmount(v); setCustom(""); }}
            className={`min-w-[68px] px-4 py-2.5 rounded-full font-semibold text-lg transition-all border-2 ${
              !custom && amount === v
                ? "bg-white text-[color:var(--brand-strong)] border-[color:var(--brand)] shadow-md scale-105"
                : "bg-white/70 text-[color:var(--text)] border-transparent hover:bg-white"
            }`}
            aria-pressed={!custom && amount === v}
          >
            {v}€
          </button>
        ))}
        <div className={`relative flex items-center rounded-full border-2 bg-white/70 transition-all ${custom ? "border-[color:var(--brand)] shadow-md" : "border-transparent hover:bg-white"}`}>
          <input
            type="number"
            min="1"
            inputMode="numeric"
            placeholder="Otro"
            value={custom}
            onChange={(e) => setCustom(e.target.value.replace(/[^0-9]/g, ""))}
            className="w-20 sm:w-24 px-3 py-2.5 bg-transparent rounded-l-full outline-none text-center font-semibold text-[color:var(--text)] placeholder:text-[color:var(--text-soft)]"
            aria-label="Importe personalizado"
          />
          <span className="pr-3 text-[color:var(--text-soft)] font-semibold">€</span>
        </div>
      </div>

      <label className="mt-4 flex items-center justify-center gap-2 text-sm text-[color:var(--text)] cursor-pointer select-none">
        <span className="relative inline-flex items-center">
          <input
            type="checkbox"
            checked={recurring}
            onChange={(e) => setRecurring(e.target.checked)}
            className="sr-only peer"
          />
          <span className="w-10 h-5 rounded-full bg-white/70 peer-checked:bg-[color:var(--brand)] transition-colors" />
          <span className="absolute left-0.5 top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5" />
        </span>
        <Repeat className="w-4 h-4" /> Donación mensual
      </label>

      <button
        onClick={donate}
        disabled={!valid}
        className="btn-accent mt-5 mx-auto w-full sm:w-auto sm:min-w-[280px] inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full font-semibold shadow-lg text-lg disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <Heart className="w-5 h-5" />
        Donar {valid ? `${activeAmount}€` : ""}{recurring && valid ? " / mes" : ""}
        <ArrowRight className="w-4 h-4" />
      </button>

      <p className="mt-3 text-xs text-center text-[color:var(--text-soft)]">
        Pago seguro mediante DonorBox. Se abrirá en una nueva ventana.
      </p>
    </div>
  );
}
